import { appLoaded } from "../search/actions";
const LOCATION_CHANGE = "@@router/LOCATION_CHANGE";

export const locationChangeMiddleware = () => store => next => action => {
  next(action);
  if (action.type === LOCATION_CHANGE) {
    const { location } = action.payload;
    store.dispatch(appLoaded(location, action.payload.action));
  }
};
